export function Services() {
  const services = [
    {
      title: 'Real Estate Sales',
      description: 'Comprehensive buying and selling services for residential properties in the St. Pete Beach and Gulf Beach area. Our experienced agents guide you through every step of the transaction.',
      features: ['Property Search & Listings', 'Market Analysis', 'Sales Preparation', 'Negotiation Support'],
      icon: 'ri-home-4-line',
      color: 'from-teal-500 to-cyan-600'
    },
    {
      title: 'Vacation Rentals',
      description: 'Short-term rental properties perfect for beach vacations on the Gulf of Mexico. Experience the beauty of St. Pete Beach with our carefully selected vacation homes.',
      features: ['Beachfront Properties', 'Flexible Terms', 'Full Amenities', 'Local Support'],
      icon: 'ri-sun-line',
      color: 'from-amber-500 to-orange-600'
    },
    {
      title: 'Annual Leases',
      description: 'Long-term rental solutions with comprehensive lease application services. Find your perfect home in the Gulf Beach area with our extensive portfolio.',
      features: ['Long-term Rentals', 'Lease Applications', 'Tenant Screening', 'Maintenance Support'],
      icon: 'ri-key-line',
      color: 'from-indigo-500 to-purple-600'
    },
    {
      title: 'Property Management',
      description: 'Professional management services for property owners. We handle everything from tenant placement to maintenance, ensuring your investment is protected.',
      features: ['Tenant Management', 'Maintenance Coordination', 'Financial Reporting', 'Legal Compliance'],
      icon: 'ri-building-line',
      color: 'from-emerald-500 to-green-600'
    }
  ];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-['Playfair_Display'] text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Services
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Comprehensive real estate solutions tailored to your needs
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group bg-gradient-to-br from-gray-50 to-white rounded-3xl p-8 border border-gray-200 hover:border-teal-300 transition-all duration-300 hover:shadow-2xl"
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${service.color} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}>
                <i className={`${service.icon} text-3xl text-white w-8 h-8 flex items-center justify-center`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{service.title}</h3>
              <p className="text-sm text-gray-600 mb-6 leading-relaxed">{service.description}</p>
              
              <ul className="space-y-3">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-sm text-gray-700">
                    <i className="ri-check-line text-teal-600 mr-3 w-5 h-5 flex items-center justify-center"></i>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}